import React, { useEffect, useRef, useState } from 'react';
import { Box, Image, ImageProps } from '@chakra-ui/react';

const basicProps = {
  position: 'absolute',
  objectFit: 'cover',
  objectPosition: 'center',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
} as const;

export interface LazyImageProps extends ImageProps {
  lqip: string;
  src: string;
  aspectRatio?: number;
}

function LazyImage({
  lqip,
  src,
  aspectRatio = 2 / 3,
  ...props
}: LazyImageProps) {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>();

  useEffect(() => {
    const img = imgRef.current;
    if (img?.complete) {
      setLoaded(true);
    }
  }, []);

  return (
    <Box width="100%" position="relative" overflow="hidden">
      <Box pb={`${100 / aspectRatio}%`} />
      <Image {...basicProps} ignoreFallback src={lqip} />
      <Image
        {...props}
        {...basicProps}
        ref={imgRef}
        loading="lazy"
        transition="opacity 1000ms"
        src={src}
        opacity={loaded ? 1 : 0}
        onLoad={() => setLoaded(true)}
      />
    </Box>
  );
}

export default LazyImage;
